import Controller from "./editableField.controller";
import template from "./editableField.html";

const editableField = {
  template,
  controller: Controller,
  transclude: true,
  bindings: {
    selected: "=",
    title: "@",
    type: "@",
    hint: "@",
    eventName: "<",
    name: "@",
    showRemove: "@",
    isRequired: "<",
    isConditional: "<",
    hideEdit: "<",
    permissionName: "@",
    resourceMethod: "@",
    resourceMethodName: "@",
    extraParams: "<",
    currency: "<",
    isPhoneObject: "<",
    city: "<",
    min: "<?",
    max: "<?",
    pattern: "<",
    patternErrorMessage: "@",
  },
};

export default editableField;



// WEBPACK FOOTER //
// ./src/components/editableField/editableField.component.js